import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLabel from '../../../library/form/components/FormLabel'
import FormTitle from '../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";

const ProfileTermsView = (props) => {
    const { formObject } = props;

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Preferred Terms' />
                    </span>
                </UiTitle>

                <UiAction>
                    <FormButton formObject={formObject} ksc="t" rowKey="" starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} value="Payment Mode" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "advPerc" }} value="Advance %" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "advPerc" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "againstDelPerc" }} value="Against Del %" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "againstDelPerc" }} className='uiVal' />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currency" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditLimit" }} value="Credit Limit" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditLimit" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} value="Credit Days" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "graceDays" }} value="Grace Days" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "graceDays" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "terms" }} value="Terms" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "terms" }} className='uiVal' />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProfileTermsView, "proTerms", "")
